import { Page404Component } from './restaurent-management/authentication/page404/page404.component';
import { AuthLayoutComponent } from './restaurent-management//layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './restaurent-management/layout/app-layout/main-layout/main-layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './restaurent-management/core/guard/auth.guard';
const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
            {
                path: 'welcome',
                loadChildren: () =>
                    import('./restaurent-management/dashboard/dashboard.module').then((m) => m.DashboardModule),
            },
            {
                path: 'koa',
                loadChildren: () =>
                    import('./restaurent-management/masters/masters.module').then((m) => m.MatersModule),
            }
        ],
    },
    {
        path: 'authentication',
        component: AuthLayoutComponent,
        loadChildren: () =>
            import('./restaurent-management/authentication/authentication.module').then(
                (m) => m.AuthenticationModule
            ),
    },
    { path: '**', component: Page404Component },
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
